import React from 'react';
import capitalize from 'lodash/capitalize';
import {
  Text,
  VStack,
  Grid,
  AspectRatio,
  Image,
  Flex,
} from '@chakra-ui/react';
import { NormalSpinner } from '../../../components';

const HoopsClusterGrid = ({ cluster, clusterInfo, showSingleHoop }) => (
  <VStack justify="space-between" p="4" spacing="8">
    <Flex justify="space-between" mb="4" w="full">
      {clusterInfo && (
        <VStack align="flex-start" spacing="1">
          <Text fontSize="xl" fontWeight="semibold">
            {clusterInfo.locationAreaName}
          </Text>
          <Text>{clusterInfo.country}</Text>
        </VStack>
      )}
    </Flex>
    <Grid
      justifyContent={[ 'center', 'flex-start' ]}
      templateColumns="repeat(auto-fit, 150px)"
      autoRows="200px"
      flex="2"
      gap="6"
      w="full"
      padding="2"
    >
      {cluster.map((hoop) => (
        <VStack
          key={hoop.id}
          justify="space-between"
          onClick={() => showSingleHoop(hoop)}
          bg="gray.100"
          boxShadow="md"
          position="relative"
          spacing="0"
          transition="all 200ms ease-in-out"
          cursor="pointer"
          sx={{ ':hover': { boxShadow: 'xl' } }}
        >
          <AspectRatio w="full" ratio={1 / 1}>
            <Image
              src={hoop.image.url}
              objectFit="cover"
              fallback={<NormalSpinner />}
            />
          </AspectRatio>
          <VStack pos="absolute" bottom="0" align="flex-start" w="full" bg="white" spacing="0" p="2" noOfLines={2}>
            <Text color="gray.500" fontSize="xs">Submitted by</Text>
            <Text fontSize="md" fontWeight="semibold" noOfLines={1}>
              {hoop.brand ? `${capitalize(hoop.brand)}` : `@${hoop.contributor.instagramHandle}`}
            </Text>
          </VStack>
        </VStack>
      ))}
    </Grid>
  </VStack>
);

export default HoopsClusterGrid;
